import dynamic from 'next/dynamic';
import { IHelpConfig, IHelpGroup } from 'mod/help/interface';
import { RouteEnum } from 'pro/config/routers';

export const helpPages: IHelpConfig['pages'] = {
    'privacy-policy': {
        title: 'Privacy Policy',
        content: {
            en: dynamic(() => import('@pro/help/PrivacyPolicy/EN')),
        },
    },
    'terms-of-use': {
        title: 'Terms of Use',
        content: {
            en: dynamic(() => import('@pro/help/TermsOfUse/EN')),
        },
    },
    'terms-of-service': {
        title: 'web_help_terms_of_service',
        content: {
            en: dynamic(() => import('@pro/help/TermsOfService/EN')),
        },
    },
    'return-policy': {
        title: 'web_help_return_policy',
        content: {
            en: dynamic(() => import('@pro/help/ReturnPolicy/EN')),
        },
    },
    'about-points': {
        title: 'web_help_about_points',
        content: {
            en: dynamic(() => import('@pro/help/AboutPoints/EN')),
        },
    },
    'shipping-types': {
        title: 'web_help_shipping_types',
        content: {
            en: dynamic(() => import('@pro/help/ShippingTypes/EN')),
        },
    },
};

export const helpGroups: IHelpGroup[] = [
    {
        key: 'Resources',
        title: 'Resources',
        link: RouteEnum.RESOURCES,
        list: [
            { title: 'User Manuals', link: RouteEnum.USER_MANUALS },
            { title: 'Product Catalogue', link: RouteEnum.PRODUCT_CATALOGUE },
            // { title: 'Video Tutorials', link: RouteEnum.VIDEO_TUTORIALS },
        ]
    },
    {
        key: 'Support',
        title: 'Support',
        link: RouteEnum.SUPPORT,
        list: [
            { title: 'Lighting Calculator', link: RouteEnum.LIGHTING_CALCULATOR },
            { title: 'Become a Dealer', link: RouteEnum.DEALER },
            { title: 'Get a Light Plan', link: RouteEnum.LIGHT_PLAN },
        ]
    },
    {
        key: 'About',
        title: 'About',
        link: RouteEnum.ABOUT_US,
    },
    {
        key: 'Contact',
        title: 'Contact',
        link: RouteEnum.CONTACT,
    },
];

export const helpGroupsWithProducts: IHelpGroup[] = [
    {
        key: 'Products',
        title: 'Products',
        link: RouteEnum.PRODUCTS,
    },
    ...helpGroups
];

export const helpConfig: IHelpConfig = {
    pages: helpPages,
    groups: helpGroups,
}
